import { isEmpty, isNil } from 'ramda';
import React from 'react';

import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import { bindActionCreators } from 'redux';

import { getCohorts } from '../../actions/Cohort/CohortAction';
import Api from '../../Api';
import Constants from '../../Constants';
import Inputs from '../Common/Inputs/Inputs';
import SelectSearchChecboxOptions from './SelectSearchChecboxOptions';
import FlashMessages, { hideMsg, showErrorMsg } from '../Common/Messages/FlashMessages';
import { Button } from './../Common/Button';
import { hasAnyError, validateAny, validateCohortName, isCohortNameExist } from '../Common/Errors/Errors';

const api = new Api();

class CohortSettings extends React.Component {
  constructor(props) {
    super(props);
    const { cohort } = this.props;
    this.state = {
      ...hideMsg,
      cohortName: cohort.name || '',
      formInputsValidation: {},
      clientIdsSelected: [],
      formSubmitted: false,
      isBusy: false,
      isEdit: cohort.id ? true : false,
    };
  }

  handleInputChange = (inputFields, value) => {
    this.setState({
      [inputFields.name]: value,
    });
  };

  async componentDidMount() {
    if (this.props.cohort.id) {
      const url = Constants.apiUrls.cohorts + '/' + this.props.cohort.id;
      try {
        const resp = await api.getData(url);
        this.setState({
          clientIdsSelected: resp.clientIdsSelected,
        });
      } catch (err) {
        console.error(err);
      }
    }
  }

  submitForm = () => {
    const { cohortName, clientIdsSelected, isBusy, isEdit } = this.state;
    const { cohort } = this.props;
    const formInputsValidation = {
      cohortName: validateCohortName(cohortName),
      isDuplicate: isCohortNameExist(cohortName, this.props.cohorts, isEdit, cohort.id),
      clientIdsSelected: validateAny(
        clientIdsSelected.length >= this.props.cohortsSelections.numberSelectionsMinRequired,
      ),
    };
    this.setState({ formInputsValidation });
    const hasErrors = hasAnyError(formInputsValidation);

    this.setState({
      formInputsValidation,
      formSubmitted: true,
    });
    !hasErrors && !isBusy ? this.saveOrUpdateCohort() : void 0;
  };

  async saveOrUpdateCohort() {
    const data = {
      name: this.state.cohortName,
      clientIdsSelected: this.state.clientIdsSelected,
      casId: this.props.casDetails.casId,
    };
    this.setState({ isBusy: true });
    try {
      this.props.isNew
        ? await api.postData(Constants.apiUrls.saveCohort + '1', { body: data })
        : await api.putData(Constants.apiUrls.cohorts + '/' + this.props.cohort.id + '?save=1', { body: data });
      this.props.getCohorts(this.props.casDetails.casId);
      this.props.afterEdit(data);
    } catch (err) {
      this.setState(showErrorMsg(err));
      this.setState({ isBusy: false });
    }
  }

  clientIdsSelectedEvent = (inputFields, id) => {
    const checkIndex = (inputFields.clientIdsSelected || []).indexOf(id);
    if (checkIndex !== -1) {
      inputFields.clientIdsSelected.splice(checkIndex, 1);
    } else if (inputFields.clientIdsSelected.length !== this.props.cohortsSelections.numberSelectionsMaxAllowed) {
      inputFields.clientIdsSelected.push(id);
    }
    this.setState({
      clientIdsSelected: inputFields.clientIdsSelected,
    });
  };

  discardForm = () => {
    this.props.afterCancel();
  };

  hideFlashMessage = () => {
    this.setState(hideMsg);
  };

  render() {
    const { msgType, msg, msgShow, clientIdsSelected, isEdit } = this.state;
    return (
      <div className="reports">
        <FlashMessages
          scope="CohortSettings"
          classNames="fl-manage-cohort"
          close={this.hideFlashMessage}
          type={msgType}
          msg={msg}
          open={msgShow}
        />
        <div className="mobile_margin signUp fontSm-15 ">
          <div className="">
            <h1 className="heading-h1-30 ScalaSansComp lineHeight-30" id="app_page_title">
              {this.props.isNew ? <span>New </span> : void 0}
              Cohort Settings
            </h1>
            <Form className="signUp-form margin-center border-gray pSm-30 bR-8">
              <Inputs
                onInputChange={this.handleInputChange}
                errorMessages={
                  this.state.formInputsValidation.cohortName || this.state.formInputsValidation?.isDuplicate
                }
                required
                title="Saved Cohort Name"
                id={'cohortName'}
                name="cohortName"
                placeholder="Cohort Name"
                value={this.state.cohortName}
              />
              <div>
                <SelectSearchChecboxOptions
                  required
                  clientIdsSelectedEvent={this.clientIdsSelectedEvent}
                  formSubmitted={this.state.formSubmitted}
                  placeholder="Search"
                  maxAllowed={this.props.cohortsSelections.numberSelectionsMaxAllowed}
                  minRequired={this.props.cohortsSelections.numberSelectionsMinRequired}
                  title={`Select ${this.props.cohortsSelections.numberSelectionsMinRequired} - ${this.props.cohortsSelections.numberSelectionsMaxAllowed} Organizations`}
                  clientIdsSelected={this.state.clientIdsSelected || []}
                  name="organization"
                  busy={
                    (isEdit && clientIdsSelected.length == 0) ||
                    (this.props.cohortsOrgsLoading && isEmpty(this.props.cohortsOrgs)) ||
                    (!this.props.isNew && isNil(this.state.clientIdsSelected))
                  }
                  dataObj={this.props.cohortsOrgs}
                  value={this.state.organization}
                />
              </div>
              <div className="text-center">
                <Button
                  isNew
                  text="Save Changes New"
                  size="large"
                  onClick={this.submitForm}
                  id="button-cohort-save-new"
                  busy={this.state.isBusy}
                  classNames={['mTop-45']}
                />

                <div className="anchorParent mTop-15">
                  <button type="button" className="anchor ref-blue-text" onClick={this.discardForm}>
                    Cancel
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    impersonate: state.Impersonate.impersonate.impersonate,
    reportLinkObj: state.Page.reportLink,
    cohorts: state.Cohort.cohorts,
    cohortsOrgs: state.CohortsOrgs.cohortsOrganizations,
    cohortsOrgsLoading: state.CohortsOrgs.loading,
    cohortsSelections: state.CohortsSelections.CohortsSelections,
    casDetails: state.AppSession.activeCasDetails,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCohorts,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(CohortSettings);
